import { useStateContext } from 'context/StateContext'
import { Modal } from 'antd'
import first from 'assets/portfolio/first1.png'
import second from 'assets/portfolio/second.png'
import third from 'assets/portfolio/third.png'
import forth from 'assets/portfolio/forth.png'
import fifth from 'assets/portfolio/fifth.png'
import sixth from 'assets/portfolio/sixth.png'
import { Helmet } from 'react-helmet-async'
import { useState } from 'react'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';

export default function Portfolio() {
    const { darkMode } = useStateContext()
    const [modal2Open, setModal2Open] = useState(false);

    return (
        <>
            <Helmet>
                {/* <Helmet/> component is used to change title, description and tags for each pages. Normally ReactJS use just one "html" file so we can't change title 
        for each page. Helmet is an external library used to add this feature */}
                <meta charSet="utf-8" />
                <title>ستيفن اريك | مَلَفّ</title>
            </Helmet>
            <div className='container' id='portfolio-section-right-to-left' data-aos="fade-left">
                <div className="row py-4 first">
                    <div className="col text-style position-relative d-flex justify-content-center">
                        <h1 className={`${darkMode ? "text-body" : "text-body-tertiary"} fw-bold `}>مَلَفّ</h1>
                        <h4 className='position-absolute align-self-center '>عملى</h4>
                    </div>
                </div>
                {/* portfolio section */}
                <div className="row g-4 g-md-3 g-xl-4 px-2 px-md-5 row-cols-1  row-cols-sm-2 row-cols-lg-3 mt-1 mb-5 d-flex align-items-center">
                    <div className="col">
                        <div className="card border-info shadow">
                            <div className="card-img">
                                <img src={first} className="card-img-top" alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">التجارة الإلكترونية</h5>
                                <p className="card-text">تصميم وتطوير الويب</p>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col text-center border-start">
                                        <button className='btn btn-outline-warning btn-sm border-0' onClick={() => setModal2Open(true)}>
                                            <VisibilityOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className="col text-center">
                                        <button className='btn btn-outline-info btn-sm border-0'>
                                            <FavoriteBorderOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card border-info shadow">
                            <div className="card-img">
                                <img src={second} className="card-img-top" alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">العقارات</h5>
                                <p className="card-text">تصميم وتطوير الويب</p>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col text-center border-start">
                                        <button className='btn btn-outline-warning btn-sm border-0' onClick={() => setModal2Open(true)}>
                                            <VisibilityOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className="col text-center">
                                        <button className='btn btn-outline-info btn-sm border-0'>
                                            <FavoriteBorderOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card border-info shadow">
                            <div className="card-img">
                                <img src={fifth} className="card-img-top" alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">وسائل التواصل الاجتماعي</h5>
                                <p className="card-text">تصميم وتطوير الويب</p>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col text-center border-start">
                                        <button className='btn btn-outline-warning btn-sm border-0' onClick={() => setModal2Open(true)}>
                                            <VisibilityOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className="col text-center">
                                        <button className='btn btn-outline-info btn-sm border-0'>
                                            <FavoriteBorderOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card border-info shadow">
                            <div className="card-img">
                                <img src={third} className="card-img-top" alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">التدوين</h5>
                                <p className="card-text">تصميم وتطوير الويب</p>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col text-center border-start">
                                        <button className='btn btn-outline-warning btn-sm border-0' onClick={() => setModal2Open(true)}>
                                            <VisibilityOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className="col text-center">
                                        <button className='btn btn-outline-info btn-sm border-0'>
                                            <FavoriteBorderOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card border-info shadow">
                            <div className="card-img">
                                <img src={forth} className="card-img-top" alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">عمل</h5>
                                <p className="card-text">تصميم وتطوير الويب</p>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col text-center border-start">
                                        <button className='btn btn-outline-warning btn-sm border-0' onClick={() => setModal2Open(true)}>
                                            <VisibilityOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className="col text-center">
                                        <button className='btn btn-outline-info btn-sm border-0'>
                                            <FavoriteBorderOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card border-info shadow">
                            <div className="card-img">
                                <img src={sixth} className="card-img-top" alt="..." />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">تعليم</h5>
                                <p className="card-text">تصميم وتطوير الويب</p>
                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col text-center border-start">
                                        <button className='btn btn-outline-warning btn-sm border-0' onClick={() => setModal2Open(true)}>
                                            <VisibilityOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className="col text-center">
                                        <button className='btn btn-outline-info btn-sm border-0'>
                                            <FavoriteBorderOutlinedIcon fontSize='small' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal
                        centered
                        width={800}
                        className='my-3'
                        open={modal2Open}
                        onOk={() => setModal2Open(false)}
                        onCancel={() => setModal2Open(false)}
                        footer={null}
                    >
                        <div className="p-0 p-sm-4">
                            <h3 className='text-center text-info fw-bold'>التجارة الإلكترونية</h3>
                            <div className='row mt-4'>
                                <div className="col">
                                    <img src={first} className='img-fluid rounded-3' alt="" />
                                </div>
                            </div>
                            <div className="row row-cols-1 row-cols-sm-2 g-3 my-4">
                                <div className="col">

                                    <strong>نوع المشروع:</strong><span> موقع إلكتروني</span>
                                </div>
                                <div className="col">
                                    <strong>التقنيات:</strong><span> رد فعل جافا سكريبت، لغة ترميز النص التشعبي</span>
                                </div>
                                <div className="col">
                                    <strong>معاينة:</strong><span> <a href="#" className='text-decoration-none'>https://themeforest.net/</a></span>
                                </div>
                                <div className="col">
                                    <strong>عميل:</strong><span> إنفاتو</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <p>الشركة نفسها هي شركة ناجحة جدا. تم إطلاق أسبيرناتور، مع الرغبة في المتابعة، دع الشخص المختار يهرب من الآلام، يمكننا أن نجد المهرب من أين! هذا الخطأ، نقودك إلى بعض الديون التي غالبا ما تسر بالحصول عليها، فلا أحد يهرب مما يسمى بالهروب السعيد للكبار، إلا من واجبات التنصل من الواجبات التي يعميها الجسد المتعب. بعض المعاناة هي بعض الطرق المختارة التي ينتج عنها دفع الحكيم لمتعة أكبر، وكأنه سيحدث للمكاتب صاحب الحق أو المخترع هل يمكن أن نمدح؟ إنه يرفض معاناة الحاضرين والسعداء، ولا يعميه التدريب والألم لبعض الوقت، وسأفتحهم للمختار، وسأشرح الطرق التي تتساوى بها المتعة نفسها مع الملذات، ومن أين ونتهمهم بالصد! فهل يقبله لأنه يكره بعض الناس الذين يمدحونه؟</p>
                                    <p>الشركة نفسها هي شركة ناجحة جدا. تم إطلاق أسبيرناتور، مع الرغبة في المتابعة، دع الشخص المختار يهرب من الآلام، يمكننا أن نجد المهرب من أين! هذا الخطأ، نقودك إلى بعض الديون التي غالبا ما تسر بالحصول عليها، فلا أحد يهرب مما يسمى بالهروب السعيد للكبار، إلا من واجبات التنصل من الواجبات التي يعميها الجسد المتعب. بعض المعاناة هي بعض الطرق المختارة التي ينتج عنها دفع الحكيم لمتعة أكبر، وكأنه سيحدث للمكاتب صاحب الحق أو المخترع هل يمكن أن نمدح؟ إنه يرفض معاناة الحاضرين والسعداء، ولا يعميه التدريب والألم لبعض الوقت، وسأفتحهم للمختار، وسأشرح الطرق التي تتساوى بها المتعة نفسها مع الملذات، ومن أين ونتهمهم بالصد! فهل يقبله لأنه يكره بعض الناس الذين يمدحونه؟</p>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </>
    )
}
